import { HttpRequestService } from "../../shared/services/http-request.service";
import { GridService } from "../../shared/services/grid.service";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

@Injectable()
export class BillingService extends GridService {
  private billingURL = '/Billing';
  private getInvoicesURL = environment.apiUrl + this.billingURL + '/GetInvoices';
  private getAnalyticsURL = environment.apiUrl + this.billingURL + '/GetVenueDatabaseAnalytics';

  constructor(private _http: HttpRequestService) {
    super();
    this.getData = this.getInvoices;
  }

  getInvoices(data) {
    return this._http.post(this.getInvoicesURL, data);
  }

  getBillingData(data) {
    const monthUrl = data.month ? '?month=' + data.month : '';
    const yearUrl = (data.year ? '&year=' + data.year : '')
    const url = this.getAnalyticsURL + monthUrl + yearUrl;

    return this._http.get(url)
  }
}

@Injectable()
export class CalcBillingService {
  private calcInvoicesURL = environment.apiUrl + '/Billing/CalcInvoices';

  constructor(private _http: HttpRequestService) {
  }

  getInvoices(data) {
    return this._http.post(this.calcInvoicesURL, data);
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/venues/venue-billing/venue-billing.service.ts